import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login'
import store from '../store/index';
import moment from 'moment';

Vue.use(VueRouter);

const isAuthenticated = (to, from, next) => {
    if (store.getters.auth) {
        if (moment().isAfter(store.getters.session_expires_at)) {
            store.dispatch('logout');
        }
        next();
    } else {
        next('/login');
    }
};

const routes = [
    {
        path: '/',
        redirect: 'recents'
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
    },
    {
        path: '/recents',
        name: 'recents',
        component: () => import('../views/Recents.vue'),
        beforeEnter: isAuthenticated,
    },
    {
        path: '/episode/:episode_id',
        name: 'episode',
        component: () => import('../views/Episode.vue'),
        beforeEnter: isAuthenticated,
    },
    {
        path: '/directory',
        name: 'directory',
        component: () => import('../views/Directory.vue'),
        beforeEnter: isAuthenticated,
    },
    {
        path: '/chat',
        name: 'chat',
        component: () => import('../views/Chat.vue'),
        beforeEnter: isAuthenticated,
    },
    {
        path: '/manga',
        name: 'manga',
        component: () => import('../views/Manga.vue'),
        beforeEnter: isAuthenticated,
    },
    {
        path: '/doramas',
        name: 'doramas',
        component: () => import('../views/Doramas.vue'),
        beforeEnter: isAuthenticated,
    },
    {
        path: '/anime/:anime_id',
        name: 'anime',
        component: () => import('../views/Anime.vue'),
        beforeEnter: isAuthenticated,
    },
    {
        path: '/favorites',
        name: 'favorites',
        component: () => import('../views/Favorites.vue'),
        beforeEnter: isAuthenticated,
    },
    {
        path: '/support',
        name: 'support',
        component: () => import('../views/Support.vue'),
        beforeEnter: isAuthenticated,
    },
    {
        path: '/openings',
        name: 'openings',
        component: () => import('../views/Openings'),
        beforeEnter: isAuthenticated,
    },
    {
        path: '/news',
        name: 'news',
        component: () => import('../views/News'),
        beforeEnter: isAuthenticated,
    },
    {
        path: '/trivia',
        name: 'trivia',
        component: () => import('../views/Trivia/Index'),
        beforeEnter: isAuthenticated,
    },
    {
        path: '/trivia/ranking',
        name: 'trivia-ranking',
        component: () => import('../views/Trivia/Ranking'),
        beforeEnter: isAuthenticated,
    },
    {
        path: '/trivia/participate/:anime_id',
        name: 'participate',
        component: () => import('../views/Trivia/Participate'),
        beforeEnter: isAuthenticated,
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

export default router
